import * as React from "react";
const DEFAULT_CONTEXT = {
  logEvent(event) {
    // eslint-disable-next-line no-console
    console.log(event);
  }

};
const Context = React.createContext(DEFAULT_CONTEXT);
Context.displayName = "Tracker";
export default Context;